import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { ExistingRoomDefaultUpdateMutation } from "./mutation";
import { viewModelToRoomInputConverter } from "../../_common/view-model-to-room-input";

import type { ProductRoomFormModel } from "../../../type";

type Props = {
	resetForm: () => void;
};

export const useRoomEditMutation = ({ resetForm }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(ExistingRoomDefaultUpdateMutation);

	const onUpdateRoom = useCallback(
		async (
			roomViewModel: ProductRoomFormModel["ViewModel"], //
		) => {
			showLoadingScreenCallback();

			const input = viewModelToRoomInputConverter({ viewModel: roomViewModel });

			const { errors } = await mutationFunc({
				variables: {
					input,
				},
			}).finally(hideLoadingScreenCallback);

			if (!errors) {
				notifyUserEventInfo({
					title: "部屋を更新しました",
				});

				resetForm();
			}
		},
		[hideLoadingScreenCallback, mutationFunc, resetForm, showLoadingScreenCallback],
	);

	return { onUpdateRoom };
};
